import React from "react";
import logo from "../../Assets/Logos/logowhite.png";
import "./Footer.scss";

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="footer" id="Footer" data-scroll-section>
        <div className="footer-content">
          <div className="footer-brand">
            <img src={logo} alt="SIDE-EYE" className="logo img-fluid" />
            <div className="footer-contact">
              <a href="mailto:contact@side-eye.com">contact@side-eye.com</a>
              <a href="tel:+15164210431">+1 (516) 421-0431</a>
            </div>
          </div>
          <div className="footer-meta">
            <div className="footer-social">
              <a
                href="https://www.instagram.com/sideeye.mov/"
                target="_blank"
                rel="noopener noreferrer"
                className="instaicon"
                aria-label="SIDE-EYE on Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27px"
                  height="27px"
                  viewBox="0 0 27 27"
                  aria-hidden="true"
                  fill="none"
                >
                  <g clipPath="url(#clip0_255_104)">
                    <path
                      d="M7.725 -0.25H19.275C23.675 -0.25 27.25 3.325 27.25 7.725V19.275C27.25 21.3901 26.4098 23.4186 24.9142 24.9142C23.4186 26.4098 21.3901 27.25 19.275 27.25H7.725C3.325 27.25 -0.25 23.675 -0.25 19.275V7.725C-0.25 5.6099 0.590221 3.58143 2.08582 2.08582C3.58143 0.590221 5.6099 -0.25 7.725 -0.25ZM7.45 2.5C6.13718 2.5 4.87813 3.02152 3.94982 3.94982C3.02152 4.87813 2.5 6.13718 2.5 7.45V19.55C2.5 22.2862 4.71375 24.5 7.45 24.5H19.55C20.8628 24.5 22.1219 23.9785 23.0502 23.0502C23.9785 22.1219 24.5 20.8628 24.5 19.55V7.45C24.5 4.71375 22.2862 2.5 19.55 2.5H7.45ZM20.7188 4.5625C21.1746 4.5625 21.6118 4.74358 21.9341 5.06591C22.2564 5.38824 22.4375 5.82541 22.4375 6.28125C22.4375 6.73709 22.2564 7.17426 21.9341 7.49659C21.6118 7.81892 21.1746 8 20.7188 8C20.2629 8 19.8257 7.81892 19.5034 7.49659C19.1811 7.17426 19 6.73709 19 6.28125C19 5.82541 19.1811 5.38824 19.5034 5.06591C19.8257 4.74358 20.2629 4.5625 20.7188 4.5625ZM13.5 6.625C15.3234 6.625 17.072 7.34933 18.3614 8.63864C19.6507 9.92795 20.375 11.6766 20.375 13.5C20.375 15.3234 19.6507 17.072 18.3614 18.3614C17.072 19.6507 15.3234 20.375 13.5 20.375C11.6766 20.375 9.92795 19.6507 8.63864 18.3614C7.34933 17.072 6.625 15.3234 6.625 13.5C6.625 11.6766 7.34933 9.92795 8.63864 8.63864C9.92795 7.34933 11.6766 6.625 13.5 6.625ZM13.5 9.375C12.406 9.375 11.3568 9.8096 10.5832 10.5832C9.8096 11.3568 9.375 12.406 9.375 13.5C9.375 14.594 9.8096 15.6432 10.5832 16.4168C11.3568 17.1904 12.406 17.625 13.5 17.625C14.594 17.625 15.6432 17.1904 16.4168 16.4168C17.1904 15.6432 17.625 14.594 17.625 13.5C17.625 12.406 17.1904 11.3568 16.4168 10.5832C15.6432 9.8096 14.594 9.375 13.5 9.375Z"
                      fill="#EFEFE7"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_255_104">
                      <rect width="27" height="27" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                className="linkedinicon"
                aria-label="SIDE-EYE on LinkedIn"
                href="https://www.linkedin.com/company/side-eye/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="28px"
                  height="27px"
                  viewBox="0 0 26 26"
                  fill="#EFEFE7"
                  aria-hidden="true"
                >
                  <g clipPath="url(#clip0_255_104)">
                    <path d="M 21.125 0 L 4.875 0 C 2.183594 0 0 2.183594 0 4.875 L 0 21.125 C 0 23.816406 2.183594 26 4.875 26 L 21.125 26 C 23.816406 26 26 23.816406 26 21.125 L 26 4.875 C 26 2.183594 23.816406 0 21.125 0 Z M 8.039063 22.070313 L 4 22.070313 L 3.976563 9.976563 L 8.015625 9.976563 Z M 5.917969 8.394531 L 5.894531 8.394531 C 4.574219 8.394531 3.722656 7.484375 3.722656 6.351563 C 3.722656 5.191406 4.601563 4.3125 5.945313 4.3125 C 7.289063 4.3125 8.113281 5.191406 8.140625 6.351563 C 8.140625 7.484375 7.285156 8.394531 5.917969 8.394531 Z M 22.042969 22.070313 L 17.96875 22.070313 L 17.96875 15.5 C 17.96875 13.910156 17.546875 12.828125 16.125 12.828125 C 15.039063 12.828125 14.453125 13.558594 14.171875 14.265625 C 14.066406 14.519531 14.039063 14.867188 14.039063 15.222656 L 14.039063 22.070313 L 9.945313 22.070313 L 9.921875 9.976563 L 14.015625 9.976563 L 14.039063 11.683594 C 14.5625 10.875 15.433594 9.730469 17.519531 9.730469 C 20.105469 9.730469 22.039063 11.417969 22.039063 15.046875 L 22.039063 22.070313 Z"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_255_104">
                      <rect width="27" height="27" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
            <p className="footer-copyright">&copy; SIDE-EYE</p>
          </div>
        </div>
      </footer>
    );
  }
}
